/**
 * Creates a object for every .components-form-Time DOM element.
 */
import {startsWith} from "lodash";
import {initializeMultiple} from "./dropifyMultiple";

common.View.create('crud::form.inputs.File', {

    // const defaultText = 'Sleep hier uw bestand' + (dropifyWrapper.find('input[type="file"]').attr('multiple') ? '(en)' : '') + ' of klik op dit vak';
    defaultText: 'Sleep hier uw bestand' + ($('input[type="file"]').attr('multiple') ? '(en)' : '') + ' of klik op dit vak',

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        // Needed for website page block editor, which most of the time won't load the preview of an image.
        setTimeout(() => {
            this.initGui();
            this.initSweetalert();
            this.initDeleteFile();
            this.initDeleteMultipleMedia();
        }, 1);
    },

    initGui() {
        // Create file upload on file field
        let dropify = this.element
            .find('input[type="file"].dropzone')
            .dropify({
                messages: {
                    'default': 'Sleep hier uw bestand' + (this.element.find('input[type="file"]').attr('multiple') ? '(en)' : '') + ' of klik op dit vak',
                    'replace': 'Sleep hier uw bestand' + (this.element.find('input[type="file"]').attr('multiple') ? '(en)' : '') + ' of klik op dit vak om het te vervangen',
                    'remove': 'Verwijderen',
                    'error': 'Het zier er naar uit dat er iets fout is gegaan'
                },
                tpl: {
                    message: '<div class="dropify-message"><svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg> <p>{{ default }}</p></div>',
                }
            })
            .end();

        initializeMultiple(dropify, this.defaultText);
    },

    /**
     * Sweet alert options
     */
    initSweetalert() {

        $('.openSwal')

            // Enable sweetalert button (always)
            .prop('disabled', false)

            // Show preview in (sweet)alert
            .on('click', (event) => {
                // Get event target, file and extension
                var $this = $(event.currentTarget),
                    file = $this.data('file'),
                    extension = $this.data('extension');

                // Sweetalert popup
                Swal.fire({
                    html: file && startsWith(extension, 'image/') ?
                        '<img class="img-fluid mb-3" src="' + file + '" />'
                        : '<embed src="' + file + '" width="100%" height="500" />',
                    heightAuto: false,
                    width: '95%',
                    confirmButtonColor: '#6366f1',
                    customClass: {
                        popup: startsWith(extension, 'image/') ? 'max-w-2xl' : 'max-w-full',
                        confirmButton: 'focus:!ring-indigo-500',
                    },
                    confirmButtonText: 'Sluiten',
                });
            });
    },

    initDeleteFile() {
        let drEvent = this.element.find('input[type="file"]');

        drEvent.on('dropify.afterClear', (event, element) => {
            this.element.find('#removeFile').val('');
        });
    },

    initDeleteMultipleMedia() {
        // Create axios post request based on data-action and data-media
        this.element.find('.deleteMedia').on('click', (event) => {
            let $this = $(event.currentTarget);

            // Sweetalert popup
            Swal.fire({
                title: 'Weet u het zeker?',
                text: "U kunt deze actie niet ongedaan maken!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ja, verwijderen!',
                cancelButtonText: 'Annuleren'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post($this.data('action'), {
                        media: $this.data('media')
                    })
                        .then((response) => {
                            // If success
                            if (response.data.success) {
                                // Remove media from DOM
                                $this.closest('.mediaFile').remove();

                                // Show success message
                                Swal.fire({
                                    title: 'Verwijderd!',
                                    text: 'De media is verwijderd.',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                            }
                        })
                        .catch((error) => {
                            // Show error message
                            Swal.fire({
                                title: 'Fout!',
                                text: 'Er is iets fout gegaan.',
                                icon: 'error',
                                showConfirmButton: false,
                                timer: 1500
                            });
                        });
                }
            });
        });
    },

});
